import React, { useContext, useEffect } from 'react'
import {
  Form,
  FormField,
  Grid,
  Button,
  GridColumn,
  GridRow,
} from 'semantic-ui-react'
import { useSelector } from 'react-redux'
import { useForm } from 'react-hook-form'
import Swal from 'sweetalert2'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import styles from './customerSettings.module.css'
import { CustomerViewContext } from '../customer-info-view/customerView'
import {
  updateCustomerSettings,
  getCustomerSettings,
} from '../../../../services/customer'

const specialChar =
  /(^[A-Za-z0-9ء-ي ]+$)|^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/

const apnSpecial = /^[a-zA-Z0-9)\\(._-]+$/g

const formValidator = {
  username: yup.lazy((value) => {
    if (value.trim().length > 0) {
      return yup
        .string()
        .trim()
        .matches(specialChar, 'Username has invalid charachters')
    }
    return yup.string()
  }),
  password: yup.string(),
  apnname: yup
    .string()
    .trim()
    .required('Apn name is required')
    .matches(apnSpecial, 'Apn name has invalid charachters'),
  url: yup
    .string()
    .required('Url is required')
    .matches(
      '^(http:\\/\\/www\\.|https:\\/\\/www\\.|http:\\/\\/|https:\\/\\/)?[a-z0-9]+([\\-\\.]{1}[a-z0-9]+)*\\.[a-z]{2,5}(:[0-9]{1,5})?(\\/.*)?|^((http:\\/\\/www\\.|https:\\/\\/www\\.|http:\\/\\/|https:\\/\\/)?([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$',
      'Invalid Domain Name',
    ),
  port: yup.string().required('Port is required'),
  min: yup.string().required('Minutes is required'),
  hours: yup.string().required('Hours is required'),
}

const CustomerConfigurations = () => {
  const product = localStorage.getItem('product')

  const { userEmail } = useSelector((store) => ({
    userEmail: store.auth.userEmail,
  }))
  const { setViewNetworkSettings, customerSettings } =
    useContext(CustomerViewContext)

  const { register, handleSubmit, errors, setValue } = useForm({
    resolver: yupResolver(yup.object().shape(formValidator)),
  })

  useEffect(() => {
    ;(async () => {
      Swal.showLoading()
      const queryParams = {
        product,
        id: customerSettings.tbCustomerId,
      }
      const res = await getCustomerSettings(queryParams)
      if (res.success) {
        res.data.map((attr) => {
          const key = attr.id.attributeKey
          if (key in formValidator) {
            setValue(key, attr.strValue)
          }
          return null
        })
        Swal.close()
      } else {
        Swal.fire(res.msg || 'Error Grabing Customer Settings', '', 'error')
      }
    })()
  }, [])

  const generateCommand = (data) => {
    let res = 'S0='
    const s0 = 128 * (data.min === 1 ? 0 : 1) + data.hours * 4
    res += s0.toString(16)
    res += `,S12=${data.apnname},S13=${data.username},S14=${data.password},S15=${data.url},S16=${data.port}`
    return res
  }

  const updateSettings = async (data) => {
    const command = generateCommand(data)
    const queryParams = {
      product,
      email: userEmail,
      id: customerSettings.tbCustomerId,
      command,
    }
    Swal.showLoading()
    const res = await updateCustomerSettings(queryParams, data)
    if (res.success || res.status === 200) {
      await Swal.fire({
        title: 'Settings Updated Successfully',
        icon: 'success',
        confirmButtonColor: 'Green',
      })
      setViewNetworkSettings(false)
    } else {
      Swal.fire(res.msg || 'Something Went Wrong', '', 'error')
    }
  }
  return (
    <>
      <Form
        style={{
          backgroundColor: 'rgb(216, 231, 234)',
          padding: 10,
          borderRadius: 9,
        }}
        onSubmit={handleSubmit(updateSettings)}
        id="customerSettings"
      >
        <div style={{ margin: '10px 0' }}>
          <p style={{ display: 'inline-block', width: '11%' }}>
            <b>APN Settings</b>
          </p>
          <p
            style={{
              display: 'inline-block',
              width: '89%',
              borderBottom: '1px solid #9a9a9a',
            }}
          ></p>
        </div>
        <Grid columns={3}>
          <GridRow>
            <GridColumn>
              <FormField>
                <span>APN Name:</span>
                <input
                  name="apnname"
                  ref={register}
                  type="text"
                  placeholder="APN Name"
                />
                <small style={{ color: 'red' }}>**</small>
                {errors.apnname && (
                  <p style={{ color: 'red' }}>{errors.apnname.message}</p>
                )}
              </FormField>
            </GridColumn>

            <GridColumn>
              <FormField>
                <span>APN Username:</span>
                <input
                  name="username"
                  ref={register}
                  type="text"
                  placeholder="APN UserName"
                />
                {errors.username && (
                  <p style={{ color: 'red' }}>{errors.username.message}</p>
                )}
              </FormField>
            </GridColumn>

            <GridColumn>
              <FormField>
                <span>APN Password:</span>
                <input
                  name="password"
                  ref={register}
                  type="password"
                  placeholder="APN Password"
                />
                {errors.password && (
                  <p style={{ color: 'red' }}>{errors.password.message}</p>
                )}
              </FormField>
            </GridColumn>
          </GridRow>
        </Grid>

        <div style={{ margin: '10px 0' }}>
          <p style={{ display: 'inline-block', width: '11%' }}>
            <b>Platform Settings</b>
          </p>
          <p
            style={{
              display: 'inline-block',
              width: '89%',
              borderBottom: '1px solid #9a9a9a',
            }}
          ></p>
        </div>

        <Grid columns={2}>
          <GridRow>
            <GridColumn>
              <FormField>
                <span>Domain Name:</span>
                <input
                  name="url"
                  ref={register}
                  type="text"
                  placeholder="IP Address"
                />
                <small style={{ color: 'red' }}>**</small>
                {errors.url && (
                  <p style={{ color: 'red' }}>{errors.url.message}</p>
                )}
              </FormField>
            </GridColumn>

            <GridColumn>
              <FormField>
                <span>Port:</span>
                <input
                  name="port"
                  ref={register}
                  type="number"
                  placeholder="Port"
                  min={0}
                />
                <small style={{ color: 'red' }}>**</small>
                {errors.port && (
                  <p style={{ color: 'red' }}>{errors.port.message}</p>
                )}
              </FormField>
            </GridColumn>
          </GridRow>
        </Grid>

        <div style={{ margin: '10px 0' }}>
          <p style={{ display: 'inline-block', width: '11%' }}>
            <b>Device Settings</b>
          </p>
          <p
            style={{
              display: 'inline-block',
              width: '89%',
              borderBottom: '1px solid #9a9a9a',
            }}
          ></p>
        </div>
        <Grid columns={2}>
          <GridRow>
            <GridColumn>
              <FormField>
                <span>Device Will Capture reading Every: (Minutes)</span>

                <select name="min" ref={register}>
                  <option value="15">15</option>
                  <option value="1">1</option>
                </select>
                <small style={{ color: 'red' }}>**</small>
                {errors.min && (
                  <p style={{ color: 'red' }}>{errors.min.message}</p>
                )}
              </FormField>
            </GridColumn>

            <GridColumn>
              <FormField>
                <span>Device Will Send Data Every: (Hours)</span>
                <input
                  name="hours"
                  ref={register}
                  type="number"
                  placeholder="Hours"
                  min={0.25}
                  max={31}
                  step={0.25}
                />
                <small style={{ color: 'red' }}>**</small>
                {errors.hours && (
                  <p style={{ color: 'red' }}>{errors.hours.message}</p>
                )}
              </FormField>
            </GridColumn>
          </GridRow>
        </Grid>

        <hr />

        <Grid>
          <Grid.Column textAlign="center">
            <Button
              from="config form"
              type="submit"
              className={styles.button}
              color="red"
            >
              Submit
            </Button>
          </Grid.Column>
        </Grid>
      </Form>
    </>
  )
}

export default CustomerConfigurations
